import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setModal } from 'actions';

import './SignatureWarningModal.scss';

const SignatureWarningModal = ({ onCancel, onConfirm }) => (
    <div className="signature-warning-modal-container">
        <div className="signature-warning-modal-title">
            <h3>ATTENTION</h3>
        </div>
        <p>
            Cette action nécessitera la resignature du RIP car celle-ci sera automatiquement supprimée
        </p>
        <p>Voulez-vous continuer ?</p>
        <div className="signature-warning-modal-buttons">
            <button
                onClick={onCancel}
                type="button"
                className="btn-cancel"
            >
                Non
            </button>
            <button
                onClick={onConfirm}
                type="button"
                className="btn-confirm"
            >
                Oui
            </button>
        </div>
    </div>
);

SignatureWarningModal.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default connect(
    null,
    (dispatch) => ({
        closeModal: () => dispatch(setModal(null)),
    }),
)(SignatureWarningModal);
